/**
 * Handle the controls and content for the change_password page.
 *
 */
export class PasswordView {
    constructor() {
        this.handle_password_controls();
    }

    /**
     * Handle toggle to hide and show password text.
     *
     * @returns {void}
     */
    handle_password_controls() : void {
        const toggle_password_btn = document.getElementById('toggle_password');
        const toggle_confirm_password_btn = document.getElementById('toggle_password2');
        const password_input = document.getElementById('password1');
        const confirm_password_input = document.getElementById('password2');

        toggle_password_btn.addEventListener('click', () => {
            if (password_input.getAttribute('type') === 'password') {
                password_input.setAttribute('type', 'text');
            } else {
                password_input.setAttribute('type', 'password');
            }
        });

        toggle_confirm_password_btn.addEventListener('click', () => {
            if (confirm_password_input.getAttribute('type') === 'password') {
                confirm_password_input.setAttribute('type', 'text');
            } else {
                confirm_password_input.setAttribute('type', 'password');
            }
        });
    }
}

export function init_change_password() : void {
    if (document.getElementById('js-change-password-controls')) {
        (() => new PasswordView())();
    }
}
